import {from} from 'rxjs';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import type * as Types from './types';

export const fetchInvoiceSettings = (institutionId: string) => {
    return RESTClient.getAuthenticatedObservable(`v2/invoicing/${institutionId}/settings`);
};

export const updateInvoiceSettings = (institutionId: string, settings: Types.InvoiceSettings) => {
    return from(updateInvoiceSettingsPromise(institutionId, settings));
};

export const updateInvoiceSettingsPromise = (institutionId: string, settings: Types.InvoiceSettings) => {
    return RESTClient.postAuthenticated(`v2/invoicing/${institutionId}/settings`, {
        header: settings.header ? settings.header : '',
        footer: settings.footer ? settings.footer : '',
        pageFooter: settings.pageFooter ? settings.pageFooter : '',
        directDebitFooter: settings.directDebitFooter ? settings.directDebitFooter : '',
        greeting: settings.greeting,
        imageId: settings.imageId ? settings.imageId : '',
        hideHours: settings.hideHours ? 1 : 0,
        detailedActuals: settings.detailedActuals ? 1 : 0,
        detailedAnnualized: settings.detailedAnnualized ? 1 : 0,
        showBalanceInEmails: settings.showBalanceInEmails ? 1 : 0,
        showDetailedTransactions: settings.showDetailedTransactions ? 1 : 0,
        showZeroVat: settings.showZeroVat ? 1 : 0,
        costCenter: settings.costCenter,
        organizationNo: settings.organizationNo,
    });
};
